// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IAPW","comment":"styles_comment__1b1Ah"};